<!-- data-progress = step1, step2, step3, step4 -->
<ng-template #templateRef>
    <div class="ra-progress-body" [attr.data-progress]='step'>
        <div class="ra-multi-stepper-labels label-blue" *ngIf="mobile">
            <div class="ra-multi-step-label">進度 1/4</div>
            <div class="ra-multi-step-label">進度 2/4</div>
            <div class="ra-multi-step-label">進度 3/4</div>
            <div class="ra-multi-step-label">進度 4/4</div>
        </div>
        <div class="ra-multi-stepper">
            <div class="ra-multi-step-item">
                <div class="ra-multi-step-stop"></div>
                <div class="ra-multi-step-line"></div>
            </div>
            <div class="ra-multi-step-item">
                <div class="ra-multi-step-stop"></div>
                <div class="ra-multi-step-line "></div>
            </div>
            <div class="ra-multi-step-item">
                <div class="ra-multi-step-stop"></div>
                <div class="ra-multi-step-line"></div>
            </div>
            <div class="ra-multi-step-item">
                <div class="ra-multi-step-stop"></div>
            </div>
        </div>
        <div class="ra-multi-stepper-labels">
            <div class="ra-multi-step-label">退休規劃</div>
            <div class="ra-multi-step-label">基金篩選與配置</div>
            <div class="ra-multi-step-label">投保資訊</div>
            <div class="ra-multi-step-label">規劃完成</div>
        </div>
    </div>
</ng-template>
